import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import CreateAttendance from './CreateAttendance';

export default function EditAttendanceList({ batchId, onBack }) {
  const [sessions, setSessions] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(()=> {
    (async()=> {
      const snap = await getDocs(
        query(collection(db,'attendance'),where('batch_id','==',batchId))
      );
      const data = snap.docs.map(d=>({ id: d.id, ...d.data() }));
      const keys = {};
      data.forEach(a=>{
        const k = `${a.date}||${a.topic}`;
        if (!keys[k]) keys[k] = { date: a.date, topic: a.topic };
      });
      setSessions(Object.values(keys));
    })();
  },[batchId]);

  return (
    <div className="space-y-4">
      <button onClick={onBack} className="text-blue-600 underline">
        &larr; Back to Batch
      </button>

      <h3 className="text-xl">Your Attendance Sessions</h3>

      {selected ? (
        <div>
          <CreateAttendance
            batchId={batchId}
            date={selected.date}
            topic={selected.topic}
            isEditMode
            onBack={() => setSelected(null)}
          />

          <button
            onClick={async()=> {
              const snap=await getDocs(
                query(
                  collection(db,'attendance'),
                  where('batch_id','==',batchId),
                  where('date','==',selected.date),
                  where('topic','==',selected.topic)
                )
              );
              await Promise.all(snap.docs.map(d=>deleteDoc(doc(db,'attendance',d.id))));
              setSelected(null);
            }}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded"
          >
            Delete Session
          </button>
        </div>
      ) : (
        <ul className="space-y-2">
          {sessions.map((s,i)=>(
            <li key={i} className="flex justify-between border-b py-2">
              <span>{s.date} – {s.topic}</span>
              <button
                onClick={()=>setSelected(s)}
                className="px-2 py-1 bg-blue-600 text-white rounded"
              >
                View / Edit
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
